import React from 'react';

import {Operator, SingleValueFilter} from 'search/SearchConstants';
import insertTextFromPaste from 'util/insertTextFromPaste';
import pickDefined from 'util/pickDefined';

import {BASE_FILTER_FORM_PROP_NAMES, BaseFilterFormProps, FilterStyle} from './base/FilterFormConstants';
import TextValueFilterForm from './base/TextValueFilterForm';

interface SingleValueTextFilterFormProps extends BaseFilterFormProps {
  filter: SingleValueFilter;
  filterStyle: FilterStyle;
  onChangeFilter: (filter: SingleValueFilter) => void;
  onEnter?: () => void;
  operators: Array<Operator>;
  onRemove?: () => void;
}

export default function SingleValueTextFilterForm(props: SingleValueTextFilterFormProps): JSX.Element {
  const skeletonProps = pickDefined(props, ...BASE_FILTER_FORM_PROP_NAMES);
  return (
    <TextValueFilterForm
      {...skeletonProps}
      filterStyle={props.filterStyle}
      onChangeOperator={(operator: Operator) => {
        props.onChangeFilter({...props.filter, operator});
      }}
      onChangeValue={(value: string) => {
        props.onChangeFilter({
          ...props.filter,
          value: value || null,
        });
      }}
      onEnter={props.onEnter}
      onPaste={insertTextFromPaste}
      operators={props.operators}
      onRemove={props.onRemove}
      selectedOperator={props.filter.operator}
      initialValue={props.filter.value ?? ''}
    />
  );
}
